import { render, staticRenderFns } from "./post-locked.vue?vue&type=template&id=a954c4e8"
import script from "./post-locked.vue?vue&type=script&lang=js"
export * from "./post-locked.vue?vue&type=script&lang=js"
import style0 from "./post-locked.vue?vue&type=style&index=0&id=a954c4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./post-locked.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports